import { definePreset } from "@primevue/themes"
import Aura from "@primevue/themes/aura"
import PrimeVue from "primevue/config"
import ConfirmationService from "primevue/confirmationservice"
import DialogService from "primevue/dialogservice"
import Ripple from "primevue/ripple"
import ToastService from "primevue/toastservice"
import TooltipDirective from "primevue/tooltip"
import type { App } from "vue"

const MyPreset = definePreset(Aura, {
  semantic: {
    // https://m2.material.io/design/color/the-color-system.html#tools-for-picking-colors
    primary: {
      50: "#def4fc",
      100: "#abe3f7",
      200: "#70d1f3",
      300: "#1ebeef",
      400: "#00b1ee",
      500: "#00a3ec",
      600: "#0095de",
      700: "#0083cb",
      800: "#0072b8",
      900: "#005297",
      950: "#003d6f",
    },
    secondary: {
      50: "#dafaf4",
      100: "#a2f1e0",
      200: "#52e8cd",
      300: "#00dbb7",
      400: "#00cea6",
      500: "#00c296",
      600: "#00b388",
      700: "#00a176",
      800: "#009067",
      900: "#007249",
      950: "#004d2b",
    },
    colorScheme: {
      light: {
        primary: {
          color: "{primary.300}",
        },
      },
    },
  },
  primitive: {
    borderRadius: {
      // Limit the border radius to 6px
      lg: "6px",
      xl: "6px",
    },
  },
  components: {
    badge: {
      sm: {
        fontSize: "0.625rem",
        minWidth: "1rem",
        height: "1rem",
      },
    },
    tag: {
      root: {
        roundedBorderRadius: "999px",
        fontWeight: "500",
      },
    },
    message: {
      colorScheme: {
        light: {
          info: {
            background: "color-mix(in srgb, {primary.50}, transparent 5%)",
            borderColor: "{primary.200}",
            color: "{primary.600}",
            shadow: "0px 4px 8px 0px color-mix(in srgb, {primary.500}, transparent 96%)",
          },
        },
      },
    },
  },
})

export const primevuePlugin = (app: App) => {
  app.use(PrimeVue, {
    theme: {
      preset: MyPreset,
      options: {
        darkModeSelector: ".dark-mode",
        cssLayer: {
          name: "primevue",
        },
      },
    },
    ripple: true,
  })
  app.directive("tooltip", TooltipDirective)
  app.directive("ripple", Ripple)
  app.use(ToastService)
  app.use(DialogService)
  app.use(ConfirmationService)
}
